import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Wrapper = styled.div`
	margin: auto;
	display: flex;
	flex-direction: column;
	margin-top: 5rem;
	@media ${Breakpoints.mobile} {
		margin-top: 0;
	}
`;

export const Container = styled.div`
	padding: 3.5rem;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	.btn-close {
		text-decoration: underline;
		border: none;
	}
`;
